/**
 * Module 02 · Connect: the Auto model sentinel (routing v2, auto selection).
 *
 * An agent, process-flow agent or conclusion may store the exact string
 * `auto` as its model. At call time data-service picks the cheapest permitted
 * model whose tier is good enough for that call (org routing rules still win
 * first). It is not a registry id, so pickers must offer it explicitly and
 * displays must name it instead of flagging it as an unknown model.
 *
 * React-free and dependency-free so services, pickers and tests share it.
 */

/** The stored sentinel. Lowercase and exact: the backend matches it as is. */
export const AUTO_MODEL_ID = 'auto';

/** Short display name wherever a stored model is shown. */
export const AUTO_MODEL_LABEL = 'Auto';

/** The picker option label. */
export const AUTO_MODEL_OPTION_LABEL = 'Auto (best model for each step)';

/** One line under a picker when Auto is chosen. */
export const AUTO_MODEL_HELP =
  'Fabric picks the cheapest allowed model that is good enough for each step; routing rules still apply.';

export function isAutoModel(id?: string | null): boolean {
  return id === AUTO_MODEL_ID;
}

/**
 * Display name for a stored model id: "Auto" for the sentinel, otherwise the
 * resolved name when known, else the raw id.
 */
export function autoAwareModelName(id: string | null | undefined, resolve?: (id: string) => string | undefined): string {
  if (!id) return '';
  if (isAutoModel(id)) return AUTO_MODEL_LABEL;
  return resolve?.(id) ?? id;
}
